/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebstartover3Inputs */

const en_placewebstartover3 = /** @type {(inputs: Placewebstartover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other website`)
};

const de_placewebstartover3 = /** @type {(inputs: Placewebstartover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Website`)
};

/**
* | output |
* | --- |
* | "Other website" |
*
* @param {Placewebstartover3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebstartover3 = /** @type {((inputs?: Placewebstartover3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebstartover3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebstartover3(inputs)
	return de_placewebstartover3(inputs)
});
export { placewebstartover3 as "placeWebStartOver" }